import {cookie, getURLParam} from './lib/cookies';

export function setCommissionJunctionCookies() {
  const CJEvent = getURLParam('CJEVENT');
  var date = new Date();
  date.setTime(date.getTime() + 90*24*60*60*1000);
  const options = {
    path: '/',
    expires: date,
    samesite: 'lax',
    domain: '.pagerduty.com'
  }
  if (CJEvent) cookie('cjevent', CJEvent, /** {Options} */ options);
}
